import type { SeptFlash48Variant } from '~/features/promotions/constants/sept-flash-48';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { septFlash48CampaignCore } from './campaign-core';
import { septFlash48CampaignSurfaces } from './surfaces';

export { SEPT_FLASH_48_CAMPAIGN_ID, septFlash48CampaignCore } from './campaign-core';

const septFlash48PromoCampaignTyped = {
  ...septFlash48CampaignCore,
  surfaces: septFlash48CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<SeptFlash48Variant>;

export const septFlash48PromoCampaign = septFlash48PromoCampaignTyped as RegisteredPromoCampaign;
